// Minimal-bar masthead (variant A from Dave's mockup).
// Replaces the previous dark status-bar Footer (variant B). Sits ABOVE
// the main content column, full-width, with a thin teal accent stripe
// across the very top and a slim white bar below carrying the wordmark,
// a pulsing health dot, support/legal links and the build version.
//
// Pings /health on mount + every 60s to flip the dot to red and show
// "Connection issue" when the server is unreachable.

import { useEffect, useState } from 'react';
import axios from 'axios';
import PhonePresence from './PhonePresence.jsx';

const APP_VERSION = '1.0.0';

export default function Masthead() {
  const [healthy, setHealthy] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const ping = () => {
      axios.get('/health', { timeout: 5000 })
        .then(() => { if (!cancelled) setHealthy(true); })
        .catch(() => { if (!cancelled) setHealthy(false); });
    };
    ping();
    const id = setInterval(ping, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return (
    <header className="app-masthead">
      {/* the "top accent" — thin teal stripe pinned to the very top */}
      <div className="app-masthead-accent" aria-hidden="true" />
      <div className="app-masthead-row">
        <span className="app-masthead-left">
          <span className="app-masthead-wm">
            XSITE<span className="app-masthead-wm-g">COMMAND</span>
          </span>
          <span className={`app-masthead-status ${healthy ? 'is-up' : 'is-down'}`}>
            <span className="app-masthead-dot" />
            {healthy ? 'All systems operational' : 'Connection issue'}
          </span>
        </span>
        <PhonePresence />
        <span className="app-masthead-right">
          <a href="mailto:david@xsitegroup.ca">Support</a>
          <a href="https://www.xsitegroup.ca/privacy" target="_blank" rel="noreferrer">Privacy</a>
          <a href="https://www.xsitegroup.ca/terms"   target="_blank" rel="noreferrer">Terms</a>
          <span className="app-masthead-ver">v{APP_VERSION}</span>
        </span>
      </div>
    </header>
  );
}
